import React from 'react';
import { useTranslation } from 'react-i18next';

import LinkList from '../LinkList';

import './style.scss';

type QuickLink = {
  title: string;
  link: string;
  className: string;
};

interface QuickLinksProps {
  quickLinks: QuickLink[];
}

const QuickLinks: React.FC<QuickLinksProps> = ({
  quickLinks,
}) => {
  const { t } = useTranslation();

  return (
    <div className="QuickLinks">
      <h3 className="QuickLinks__title label--regular">{t('components.quicklinks.title')}</h3>
      <LinkList>
        {quickLinks.map((link, index) => (
          <LinkList.Item
            // eslint-disable-next-line react/no-array-index-key
            key={`${index}${link.title}`}
            title={link.title}
            link={link.link}
            titleClassName={link.className}
            icon="arrow_downward"
          />
        ))}
      </LinkList>
    </div>
  );
};

export default QuickLinks;
